import React from "react"
import { AspectRatio, Flex, useMediaQuery } from "@chakra-ui/react"
import Image from "next/image"
import { hookBreakpoints } from "theme/breakpoints"
import { navigate } from "utils/routes"
import {
  QuizInsertButton,
  QuizInsertContainer,
  QuizInsertCopy,
} from "./QuizInsert.styles"
import { useQuizInsertTracking } from "./useQuizInsertTracking"
import { colours } from "@shared/ui.design-system"

export const QuizInsert: React.FC = () => {
  const [isMobile] = useMediaQuery([hookBreakpoints.tabletMax])
  const imagePosition = isMobile ? "50% 20%" : ""
  const { trackingRef, trackQuizClick } = useQuizInsertTracking()
  const navigateToQuiz = () => {
    trackQuizClick()
    navigate("/quiz/skincare")
  }
  return (
    <QuizInsertContainer ref={trackingRef}>
      <AspectRatio
        minH={{ base: "10.1875rem", md: "12.1875rem", lg: "100%" }}
        minW={{ base: "10.25rem", lg: "14.25rem" }}
        ratio={{ base: 2 / 1, lg: 1 / 1 }}
        position="relative"
      >
        <Image
          alt="Quiz insert image"
          src="/images/search/quiz-insert.jpg"
          fill
          style={{
            objectFit: "cover",
            objectPosition: imagePosition,
          }}
        />
      </AspectRatio>
      <Flex
        w="100%"
        p={2}
        backgroundColor={colours.secondary.soft}
        flexDirection="column"
      >
        <QuizInsertCopy
          variant="apercu"
          fontSize={{ base: 4, lg: 6 }}
          mt={0}
          lineHeight={5}
        >
          Not sure what your skin needs?
        </QuizInsertCopy>
        <QuizInsertCopy
          variant="acuminRegular"
          fontSize={1}
          mt={-5}
          lineHeight={0}
        >
          Just take this quick and easy quiz to find the products that will work
          magic on your skin.
        </QuizInsertCopy>
        <QuizInsertButton onClick={navigateToQuiz} variant="secondary">
          Take the Skincare Quiz
        </QuizInsertButton>
      </Flex>
    </QuizInsertContainer>
  )
}
